import { useState, useEffect, Dispatch, SetStateAction } from "react";
import { ActiveUserService, DeleteUserService, UsersService } from "../../../services/users";
import { IUseBoolean, useBoolean } from "../../../hooks/use-boolean";
import useTable, { IUseTable } from "../../../hooks/use-table";
import { userOrderOptions } from "../../../constants/user";
import { IPagination } from "../../../types/pagination";
import { IUser } from "../../../types/user";
import { enqueueSnackbar } from "notistack";

interface IUseUserList {
    usersList: IPagination<IUser> | null;
    name: string;
    setName: Dispatch<SetStateAction<string>>;
    loading: IUseBoolean;
    table: IUseTable;
    getUsers: () => Promise<void>;
    deleteUser: (id: number) => Promise<void>;
    activeUser: (id: number) => Promise<void>;
}

const useUserList = (): IUseUserList => {

    const loading = useBoolean(true);
    const table = useTable({
        defaultSortBy: userOrderOptions[0].sortBy,
        defaultDirection: userOrderOptions[0].direction
    });

    const [usersList, setUsersList] = useState<IPagination<IUser> | null>(null);
    const [name, setName] = useState<string>('');

    const getUsers = async () => {
        loading.onTrue();
        
        await UsersService(name, table).then(resp => {
            setUsersList(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        loading.onFalse();
    };

    const deleteUser = async (id: number) => {        

        loading.onTrue();

        await DeleteUserService(id).then(resp => {
            enqueueSnackbar(resp.data.message);
            getUsers();
        }).catch(error => {
            loading.onFalse();
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

    }

    const activeUser = async (id: number) => {
        loading.onTrue();

        await ActiveUserService(id).then(resp => {
            enqueueSnackbar(resp.data.message);
            getUsers();
        }).catch(error => {
            loading.onFalse();
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });
    }

    useEffect(() => {
        getUsers();
    }, [name, table.page, table.direction, table.sortBy, table.pageSize]);

    return {
        usersList,
        name,
        setName,
        loading,
        table,
        getUsers,
        deleteUser,
        activeUser
    };
}

export default useUserList;